import { ThemeOptions, createTheme } from '@material-ui/core';
import { LightThemePalette, spacing, themeColors } from './LightTheme';

export const LegacyLightThemeOptions: ThemeOptions = {
    overrides: {
        MuiButton: {
            outlined: {
                padding: '9px 37px',
            },
            root: {
                fontSize: '1rem',
                padding: '10px 38px',
            },
            text: {
                padding: '10px 38px',
            },
        },
        MuiFormGroup: {
            root: {
                marginBottom: '15px',
            },
        },
        MuiListItem: {
            button: {
                '&:hover': {
                    backgroundColor: 'transparent',
                },
            },
            root: {
                '&$selected': {
                    '&:hover': {
                        backgroundColor: 'transparent',
                    },
                    backgroundColor: 'transparent',
                    // TODO: use theme value
                    color: themeColors.primary,
                    fontWeight: 500,
                },
                '&:hover': {
                    backgroundColor: 'transparent',
                },
                color: themeColors.textSecondary,
                padding: '6px 0px',
            },
        },
        MuiListItemIcon: {
            root: {
                minWidth: '38px',
            },
        },
        MuiListItemText: {
            root: {
                fontSize: '16px',
            },
        },
        MuiTableBody: {
            root: {
                '& th': {
                    fontWeight: 500,
                },
                '& th, td': {
                    fontSize: '1rem',
                    paddingBottom: `${spacing(1)}px`,
                    paddingTop: `${spacing(1)}px`,
                },
            },
        },
        MuiTableCell: {
            root: {
                borderBottom: `1px solid ${themeColors.primary}`,
            },
        },
        MuiTableFooter: {
            root: {
                '& tfoot': {
                    fontSize: '1rem',
                    paddingBottom: `${spacing(1)}px`,
                    paddingTop: `${spacing(1)}px`,
                },
            },
        },
        MuiTableHead: {
            root: {
                '& th': {
                    borderBottom: `2px solid ${themeColors.primary}`,
                    color: themeColors.textSecondary,
                    fontSize: '1rem',
                    paddingBottom: `${spacing(1)}px`,
                    paddingTop: `${spacing(1)}px`,
                },
            },
        },
        MuiTypography: {
            caption: {
                fontSize: '0.9rem',
                fontWeight: 400,
                lineHeight: 1.66,
            },
            gutterBottom: {
                marginBottom: '0.45em',
            },
            h1: {
                fontSize: '2.625rem',
                fontWeight: 500,
                lineHeight: 1.5,
            },
            h2: {
                fontSize: '2.25rem',
                fontWeight: 500,
                lineHeight: 1.38,
            },
            h3: {
                fontSize: '2rem',
                fontWeight: 500,
                lineHeight: 1.25,
            },
            h4: {
                fontSize: '1.5rem',
                fontWeight: 500,
                lineHeight: 'normal',
            },
            h5: {
                fontSize: '1.25rem',
                fontWeight: 500,
                lineHeight: 'normal',
            },
            h6: {
                fontSize: '1rem',
                fontWeight: 500,
                lineHeight: 'normal',
            },
        },
    },
    palette: {
        action: {
            disabledOpacity: 0.5,
        },
        ...LightThemePalette,
    },
    props: {
        MuiButton: {
            disableElevation: true,
            disableRipple: true,
            variant: 'contained',
        },
        MuiButtonBase: {
            disableRipple: true,
        },
        MuiCheckbox: {
            color: 'primary',
        },
        MuiListItem: {
            button: true,
            disableGutters: true,
        },
        MuiListItemText: {
            primaryTypographyProps: {
                style: {
                    fontSize: '1.15rem',
                },
            },
        },
        MuiRadio: {
            color: 'primary',
        },
    },
    typography: {
        button: { fontFamily: 'Space Mono,sans-serif', textTransform: 'none' },
        fontFamily: 'GalanoGrotesque,Poppins,sans-serif',
        /*
         * FontSize: 14,
         * HtmlFontSize: 10,
         */
    },
};

export const LegacyLightTheme = createTheme(LegacyLightThemeOptions);
